import {axiosPost, axiosGet, axiosDelete, DOMAIN, axiosGetDetail} from "@/network/request.js";
import { dataURLtoBlob, dataURLtoFile } from "@/common/utils/image.js";
import Qs from 'qs';
import Axios from 'axios';
import store from "@/store"
 /*const username = '';
 const userId = '';*/
 // const username = store.state.devOps.userInfo.devops_name? store.state.devOps.userInfo.devops_name : '';
 // const userId = store.state.devOps.userInfo.userId? store.state.devOps.userInfo.userId : '';
const username = store?.state?.devOps?.userInfo?.devops_name ?? '';
const userId = store?.state?.devOps?.userInfo?.userId ?? '';

export const getDevopsPerformance = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost(`/devops/performance?action=list&project_name=gitlab`, params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
/**
 * @description 获取select
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceStageSelectmapApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/stage/selectmap', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取指定空间任务与关联阶段信息,也用于搜索
 * @param {space,title,user,later_state,start_date,end_date} params
 * @returns
 */
export const getDevOpsSpaceListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/task?task_action=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
/**
 * @description 创建任务
 * @param {git ,title,user,describe,module，project_url } params
 * @returns
 */
export const postDevopsMsgMTTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/message/manual-trigger', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 修改任务信息
 * @param {id,title,user,describe,space} params
 * @returns
 */
export const postDevopsSpaceTaskUpdateApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/develop/task?action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取任务阶段设置信息
 * @param {task_id,stage_id} params
 * @returns
 */
export const getDevOpsSpaceListStageParmApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/task?task_action=list_stage_parm', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 修改任务阶段设置信息
 * @param {task_id,stage_id} params
 * @returns
 */
export const postDevopsSpaceTaskUpdateStageParmApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/task?task_action=update_stage_parm', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取任务阶段的执行历史信息
 * @param {task_id,stage_id} params
 * @returns
 */
export const getDevOpsSpaceListStageOutputApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/task?task_action=list_stage_output', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 执行额外部署  执行代码质量检测 测试计划更新接口 行为记录提交
 * @param {} params
 * @returns
 */
export const postDevopsSpaceStageActionApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/stage/new_action', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
export const postDevopsSpaceStageActionNewApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/stage/bushu', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取所有env
 * @param {module_name} params
 * @returns
 */
export const postODUDADcreateApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    params = Qs.stringify(params);
    const res = await axiosPost('/opermart/deploy-utils/docker-application-deploy/create/?process_allinfo=true', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取任务阶段的执行历史信息
 * @param {task_id,stage_id} params
 * @returns
 */
export const getDevOpsSpaceListDeployProdAllApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/task?task_action=new_list_deploy_prod_all', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 执行全量发布
 * @param {module_name} params
 * @returns
 */
export const postDeployProdAllApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/task?task_action=new_deploy_prod_all', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取任务阶段的执行历史信息
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceProducerListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/develop/task?action=list&project_name=demand', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
/**
 * @description 技术评审
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceReviewListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/project?project_action=list_review', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
/**
 * @description 新建项目
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceCreateProducerApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/project?project_action=create', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 更新项目
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceUpdateProducerApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/project?project_action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 新建项目负责人
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceCreateReviewerApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/project?project_action=create_review', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 更新项目负责人
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceUpdateReviewerApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/project?project_action=update_review', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取项目负责人信息
 * @param {id} params
 * @returns
 */
export const getDevOpsSpaceDetailReviewerApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/project?project_action=list_review', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 新建任务
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceCreateTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/develop/task?action=add', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 删除项目
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceDeleteProducerApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/project?project_action=delete', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 删除任务
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceDeleteTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/develop/task?action=delete', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 删除测试任务
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceDeleteTestTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/test/task?action=delete', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取项目信息
 * @param {id} params
 * @returns
 */
export const getDevOpsSpaceProducerDetailApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet(`/devops/space/project?project_action=get`, params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取任务信息
 * @param {id} params
 * @returns
 */
export const getDevOpsSpaceTaskDetailApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/develop/task?action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 项目分享
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceProducerShareApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/project?project_action=share', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取评论接口
 * @param {id} params
 * @returns
 */
export const getDevOpsSpaceProducerCommentApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/project?project_action=list_cm', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 新建评论
 * @param {id,comment} params
 * @returns
 */
export const postDevOpsSpaceProducerCreateCommentApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/project?project_action=create_cm', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 更新评论
 * @param {id,comment,cid} params
 * @returns
 */
export const postDevOpsSpaceProducerUpdateCommentApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/project?project_action=update_cm', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 删除评论
 * @param {id,cid} params
 * @returns
 */
export const postDevOpsSpaceProducerDeleteCommentApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/project?project_action=delete_cm', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 图片上传
 * @param {img} params
 * @returns
 */
export const postUploadImg = async function (params = {}) { //img  =>  base64图片地址
  let param = new FormData(); //创建form对象
  param.append('file', dataURLtoFile(params.img));// base64 转  二进制流   multipartFile => 后端要求的参数
  try {
    const ret = await Axios({
      method: 'post',  // post 方式
      url: 'https://devops-test.ehsy.com/devops/common/upload',  // 接口地址
      headers: { // 设置请求头
        "Content-Type": "multipart/form-data"
      },
      data: param  // 参数
    })
    return ret;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取环境占用list
 * @param {id,cid} params
 * @returns
 */
export const postDeployCenterApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/opermart/deploy-utils/deploy-center/', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 解除占用
 * @param {id,cid} params
 * @returns
 */
export const postDeployRecordingApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/common/deploy/recording', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 自定义接口
 * @param {id} params
 * @returns
 */
export const getAutoCustomerApi = async function (url, params = {}) {
  try {
    const res = await axiosGet(url, params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取sql文件内容
 * @param {id} params
 * @returns
 */
export const getEdiApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/task?task_action=new_get_edi', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 更新sql文件内容
 * @param {id,content} params
 * @returns
 */
export const postUpdateEdiApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/task?task_action=new_update_edi', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 设置技术评审人
 * @param {pid,tid,tech_reviewer,"stage_id":5,"user_rd} params
 * @returns
 */
export const postTechReviewerApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/task?task_action=update_techreviewer', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取bug
 * @param {tid} params
 * @returns
 */
export const getListMetersphereBugsApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/task?task_action=list_metersphere_bugs', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取报表
 * @param {report_type} params
 * @returns
 */
export const getReportListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/task?task_action=report', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 测试计划获取接口
 * @param {report_type} params
 * @returns
 */
export const getMetersphereTestplanBindApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/stage/action?action=metersphere_testplan_bind&testplan_type=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 问题反馈列表
 * @param {report_type} params
 * @returns
 */
export const getSuggestListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/common/suggestbox?suggest_action=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 问题反馈创建
 * @param {report_type} params
 * @returns
 */
export const postSuggestCreateApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/common/suggestbox?suggest_action=create', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 问题反馈更新
 * @param {report_type} params
 * @returns
 */
export const postSuggestUpdateApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/common/suggestbox?suggest_action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 分支更新
 * @param {tid,branch} params
 * @returns
 */
export const postUpdateDevbranchApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/task?task_action=update_devbranch', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 需求模块技术评审人回退
 * @param {tid,branch} params
 * @returns
 */
export const postDevOpsSpaceReviewerRollbackApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/project?project_action=back_review', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 需求模块产品修改需求状态
 * @param {tid,branch} params
 * @returns
 */
export const postDevOpsSpaceUserPmEditStatusApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/demand?action=update&project_name=status', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 需求模块产品修改需求状态
 * @param {tid,branch} params
 * @returns
 */
export const postDevOpsSpaceUserPmEditReviewerApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/project?project_action=update_reviewer', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 统计首页
 * @param {project_system,p_category,start_date,end_date} params
 * @returns
 */
export const getStatisticsApi = async function(params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/project?project_action=echarts_info', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
/**
 * @description 统计详情
 * @param {emp,project_system,p_category,title,task_title,task_status,start_date,end_date} params
 * @returns
 */
export const getStatisticsDetailApi = async function(params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/project?project_action=echarts_personal', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
/**
 * @description 需求页面
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceDemandListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/project?project_action=list_new', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
/*
* 创建其他任务
* */
export const postDevOpsSpaceCreateOtherTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/other/task?action=add', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 其他任务列表页
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceOtherListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/other/task?action=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取任务详情
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceOtherDetailApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/other/task?action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 编辑任务
* */
export const postDevOpsSpaceUpdateOtherTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/other/task?action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}




/*
* 测试任务
* */
export const postDevOpsSpaceTestTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/task?task_action=tester_tasks', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* uat任务
* */
export const postDevOpsSpaceUatApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/task?task_action=uat', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 线上验证任务
* */
export const postDevOpsSpaceVerifyApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/task?task_action=online_verification', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 任务清单
* */
export const postDevOpsSpaceAllTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/task?task_action=all_task_line', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 开发任务
* */
export const postDevOpsSpaceDevTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/task?task_action=developer_tasks', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 创建Bug任务
* */
export const postDevOpsSpaceCreateBugTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/bug/task?action=add', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
*
* */
export const postDevOpsSpaceAllBugTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/bug/task?action=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取BUG任务详情
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceBugDetailApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/bug/task?action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 编辑任务
* */
export const postDevOpsSpaceUpdateBugTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/bug/task?action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 导入缺陷
* */
export const postDevOpsSpaceBugExcelTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost(`/devops/space/task-file?task_action=bug_excel&username=${username}&userId=${userId}`, params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 编辑任务
* */
export const postDevOpsSpaceUpdateProjectReviewApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/task?task_action=create_project_technical_reviewer', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
/*
* 增加项目体系
* */
export const getDevOpsSpaceAddProjectSystemApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/project?project_action=config_auto', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 获取开发人员
* */
export const getDevOpsSpaceDevopsUserApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/task?task_action=devops_user', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 新增开发人员
* */
export const postDevOpsSpaceCreateDevopsUserApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/task?task_action=create_devops_user', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 编辑开发人员
* */
export const postDevOpsSpaceUpdateDevopsUserApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/task?task_action=update_devops_user', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
/* 以下是新增项目新增更改的接口 2023-11-20*/
/*
* 创建项目
* */
export const postDevOpsSpaceCreateProjectApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/project?action=add', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 编辑项目
* */
export const postDevOpsSpaceEditProjectApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/project?action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 获取项目列表
* */
export const getDevOpsSpaceAllProjectApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project?action=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 变更项目状态
* */
export const postDevOpsSpaceUpdateProjectStatusApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/project?action=update&project_name=status', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 获取项目详情
* */
export const getDevOpsSpaceFindOneProjectApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project?action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 创建项目记录
* */
export const postDevOpsSpaceCreateProjectRecordApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/project?action=add&project_name=record', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 获取项目记录
* */
export const getDevOpsSpaceFindProjectRecordApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project?action=get&project_name=record', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 项目记录评论
* */
export const postDevOpsSpaceCreateProjectInsertCommentApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/comment?action=add', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
export const postDevOpsSpaceCreateNoteApi = async function (params = {}) {
  try {
    const res = await axiosPost('/devops/demand?action=note', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
export const getDevOpsSpaceNoteApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/space/project?project_action=list_cm', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
/*
* 获取项目评论
* */
export const getDevOpsSpaceFindProjectCommentApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/comment?action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 更新项目评论
* */
export const postDevOpsSpaceUpdateProjectCommentApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/space/project?project_action=update_comment', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 删除项目评论
* */
export const postDevOpsSpaceDeleteProjectCommentApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/comment?action=delete', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 获取项目名称
* */
export const getDevOpsSpaceFindProjectNameApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project?action=list&project_name=name', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/*
* 创建需求
* */
export const postDevOpsSpaceCreateDemandApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/demand?action=add', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 编辑需求
* */
export const postDevOpsSpaceEditDemandApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    if (params.note) {
      delete params.note;
    }
    const res = await axiosPost('/devops/demand?action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 需求提交接口
* */
export const postDevOpsSpaceSubmitDemandApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/demand?action=submit', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/*
* 获取需求列表
* */
export const getDevOpsSpaceAllDemandListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/demand?action=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 获取需求详情
* */
export const getDevOpsSpaceFindOneDemandApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/demand?action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 新增会议
* */
export const postDevOpsSpaceAddMettingApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/meeting?action=add', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 更新会议
* */
export const postDevOpsSpaceUpdateMettingApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/meeting?action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 获取会议列表
* */
export const getDevOpsSpaceMeetListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/meeting?action=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/*
* 获取会议详情
* */
export const getDevOpsSpaceDetaileMeetingApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/meeting?action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 提交任务接口
* type （1：开发，2：提测）
* */
export const postDevOpsSpaceSubmitTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/develop/task?action=submit', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/*
* 查询测试任务关联开发任务列表接口
* */
export const getDevOpsSpaceFindDevelopTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/develop/task?action=list&project_name=test', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 新建测试任务
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceCreateTestTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/test/task?action=add', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 编辑更新测试任务
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceUpdateTestTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/test/task?action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/*
* 查询需求页面测试任务列表
* */
export const getDevOpsSpaceDemandTestTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/test/task?action=list&project_name=demand', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 查询需求页面测试任务列表
* */
export const getDevOpsSpaceTestTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/test/task?action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 测试任务页开发任务列表
* */
export const getDevOpsSpaceDevelopTestTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/test/task?action=list&project_name=develop', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 编辑更新测试任务
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceSUbmitTestTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/test/task?action=submit', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 查任务首页列表接口
* */
export const getDevOpsSpaceDevelopDevTaskListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/develop/task?action=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
/*
* 查任务首页列表接口-
* */
export const getDevOpsSpaceDevelopDevTaskNewListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/develop/task?action=own_task_order', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
// 操作记录
export const postDevOpsSpaceDevelopDevTaskNewUpdateLogApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/develop/task?action=update_task_order_log', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
// 修改
export const postDevOpsSpaceDevelopDevTaskNewUpdateApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/develop/task?action=update_task_order', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
/*
* 查询测试任务首页列表接口
* */
export const getDevOpsSpaceTestTaskListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/test/task?action=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 查询发布申请开发任务列表
* */
export const getDevOpsSpaceDeployApplyTaskListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/develop/task?action=list&project_name=deploy_apply', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 查询状态历史信息接口
* */
export const getDevOpsSpaceHistoryTaskListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project/status?action=list&project_name=change', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/*
* 所有清单列表
* */
export const getDevOpsSpaceAllTaskListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/develop/task?action=list&project_name=task', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/*
* 查询任务清单任务状态列表接口
* */
export const getDevOpsSpaceAllStatusListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project/status?action=list&project_name=task', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/*
* 查询UAT需求清单列表接口
* */
export const getDevOpsSpaceUatListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/demand?action=list&project_name=UAT', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 查询线上验证需求清单列表接口
* */
export const getDevOpsSpaceDeployListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/demand?action=list&project_name=deploy', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 查询技术评审清单列表接口
* */
export const getDevOpsSpaceNewReviewListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/demand?action=list&project_name=review', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 缺陷任务页获取关联测试任务列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceBugRelTestTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/test/task?action=list&project_name=bug', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 缺陷任务页获取关联任务列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceBugRelTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/develop/task?action=list&project_name=bug', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 缺陷任务提交接口
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceNewSUbmitBugApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/bug/task?action=submit', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 查询发布任务列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceDeployApplyApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/develop/task?action=list&project_name=deploy', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 日报获取开发任务列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceReportTaskListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/daily/task?action=list&project_name=develop', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 日报获取测试任务列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceReportTestTaskListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/daily/task?action=list&project_name=test', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}



/**
 * @description 提交任务日报接口
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceSUbmitReportApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/daily/task?action=submit', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 提交任务日报接口
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceSUbmitOtherTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/other/task?action=submit', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 修改分支接口
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceUpdateBranchApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/develop/task?action=update&project_name=branch', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 查询代码审核人列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceReviewUserListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project/user?action=list&&project_name=review', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 查询延期原因列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceDelayReasonListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/task/delay/reason?action=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 任务延期原因提交接口
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceSUbmitDelayReasonApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/task/delay/reason?action=submit', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 更新git分支
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceUpdateGitApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/develop/task?project_name=git&action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 查询git分支列表
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceGitListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/develop/task?module_name=dg&project_name=git&action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 查询commit
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceCommitListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/develop/task?project_name=commit&action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 查询环境env
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceEnvListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/develop/task?project_name=env&action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 绩效报表总数接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpacePerformanceListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/performance?action=lists', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 绩效报表详细列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpacePerformanceDetailListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/performance?action=submit', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 查询日报列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceDailyTaskReportListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/daily/task?action=list&project_name=report', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 查询日报详细列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceDailyTaskReportDetailApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/daily/task?action=list&project_name=detail', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 查询团队列表
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceTeamListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/team?action=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 查询人员列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceUserManageListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project/user?action=list&project_name=manage', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 查询人员详情接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceUserDetailApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project/user?action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}



/**
 * @description 查询人员角色列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceUserRoleListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/role?action=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 更新用户数据
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceUpdateUserApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/project/user?action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 删除用户
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceDleteUserApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/project/user?action=delete', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 添加角色
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceAddRolerApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/role?action=add', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 编辑角色
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceUpdateRolerApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/role?action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 查询人员角色列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceRoleListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/role?action=list&project_name=manage', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 查询角色详情接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceRoleDetailApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/role?action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 添加团队
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceAddTeamApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/team?action=add', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 编辑团队
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceUpdateTeamApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/team?action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 查询团队首页列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceTeamIndexListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/team?action=list&project_name=manage', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 查询团队详情接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceTeamDetaililApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/team?action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 查询体系首页列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceSystemListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project/system?action=list&project_name=manage', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 新增体系接口
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceAddSystemApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/project/system?action=add', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 更新体系接口
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceUpdateSystemApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/project/system?action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}



/**
 * @description 查询项目体系详情接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceSystemDetailApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project/system?action=get', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 查询项目报表列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceProjectPerformanceListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project/performance?action=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 查询项目报表详情列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceProjectPerformanceDetailApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project/performance?action=list&project_name=manage', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 查询项目报表扇形图接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceProjectPerforchartDetailApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/project/performance?action=list&project_name=chart', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 查询菜单列表接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceSettingMenuListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/menu?action=list&project_name=manage', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 查询菜单详情接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceSettingMenuDetailApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/menu?action=get&project_name=manage', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 根据菜单类型查找接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceSettingMenuTypeApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/menu?action=list&project_name=menu_type', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 新增菜单接口
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceAddMenuApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/menu?action=add', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}



/**
 * @description 编辑菜单接口
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceUpdateMenuApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/menu?action=update', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 首页剩余工作接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceIndexCountApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/home?action=list&project_name=count', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 首页提醒工作接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceIndexRemindApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/home?action=list&project_name=remind', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 首页最近参加项目接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceIndexProjectListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/home?action=list&project_name=project', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 首页最近参加需求接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceIndexDemandListApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/home?action=list&project_name=demand', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 首页我的贡献接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceIndexContributeApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/home?action=get&project_name=contribute', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 首页进度
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceIndexProgressApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/home?action=list&project_name=all', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 首页我的待处理
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceIndexUndoneApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/home?action=get&project_name=undone', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 首页最新动态接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceIndexdDynamicApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/home?action=get&project_name=dynamic', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 人效统计
 * @param {} params
 * @returns
 */
export const getDevOpsSpacePersonnelDetailApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/performance?action=get&project_name=personnel', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 人效统计
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceDemandSkipApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/demand?action=skip', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 我的待处理数量
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceDynamicCountApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/home?action=list&project_name=dynamic_count', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 我的首页数据
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceIndexAllDataApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosGet('/devops/home?project_name=home&action=all', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 更新计划完成日期
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceUpdatePlanDateApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/demand?action=update&project_name=planFinishDate', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 批量创建开发,测试任务
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceBatchCreateTaskApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/export_import_task?action=export&project_name=task', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 登陆接口
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceLoginApi = async function (params = {}) {
  try {
    const res = await axiosPost('/devops/devops_login?action=post&project_name=login', params, 'noLogin');
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 获取token信息
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceTokenDataApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }


    const res = await axiosGetDetail('/devops/devops_login?action=get&project_name=login', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取组织架构
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceDeptApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/work_order?action=get&project_name=dept_mgs', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}



/**
 * @description 新增系统
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceCreateSystemApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/work_order?action=post&project_name=models_code', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 获取人员部门信息
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceUserDepartmentInfoApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/work_order?action=get&project_name=redis_dept', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 创建工单
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceCreateWorkOrderApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/work_order?action=post&project_name=work_order', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 工单首页
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceWorkOrderIndexApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/work_order?action=get&project_name=all', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 我的工单
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceMyWorkOrderApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/work_order?action=get&project_name=list', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 待办工单
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceDealWorkOrderApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/work_order?action=get&project_name=unlist', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 认领工单
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceClaimWorkOrderApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/work_order?action=submit&project_name=work_order', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}



/**
 * @description 工单详情 * @param {} params
 * @returns
 */
export const getDevOpsSpaceWorkOrderDetailApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/work_order?action=get&project_name=work_order', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 编辑工单
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceUpdateWorkOrderApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/work_order?action=update&project_name=work_order', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}



/**
 * @description 工单需求列表 * @param {} params
 * @returns
 */
export const getDevOpsSpaceWorkOrderDemandListlApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/work_order?action=list&project_name=work_demand', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 工单任务列表 * @param {} params
 * @returns
 */
export const getDevOpsSpaceWorkOrderTaskListlApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/work_order?action=list&project_name=work_other_work', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 提醒/验证/评价工单接口
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceCheckWorkOrderApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/work_order?action=submit&project_name=remind_check_eva', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 催单/跟单列表 * @param {} params
 * @returns
 */
export const getDevOpsSpaceReminderWorkOrderListlApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/work_order?action=list&project_name=work_log', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 工单分类列表 * @param {} params
 * @returns
 */
export const getDevOpsSpaceWorkOrderCategoryListlApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/work_order?action=list&project_name=config_type', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 导出需求 * @param {} params
 * @returns
 */
export const getDevOpsSpaceExportDemandApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/space/reporter/export?source_type=demand', params,'TOPS',{ responseType: "blob" });
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 类别查询 * @param {} params
 * @returns
 */
export const getDevOpsSpaceDictionariesTypeListlApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/work_order?action=list&project_name=dictionaries_type', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 创建类别
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceCreateDictionariesTypeApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/work_order?action=post&project_name=dictionaries_type', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 修改类别
 * @param {} params
 * @returns
 */
export const postDevOpsSpaceUpdateWorderOederTypeApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }
    const res = await axiosPost('/devops/work_order?action=update&project_name=config_type', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}


/**
 * @description 人效周报 * @param {} params
 * @returns
 */
export const getDevOpsSpaceWeeeklyReportApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/performance?action=get&project_name=weekly', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}
// 季度指标报表
export const getDevOpsSpaceQuarterReportReportApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosPost('/devops/performance?action=list&project_name=index', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/**
 * @description 新的人效周报 * @param {} params
 * @returns
 */
export const getDevOpsSpaceWeeeklysReportApi = async function (params = {}) {
  try {
    if (!params?.username) {
      username && (params.username = username);
    }
    if (!params?.userId) {
      userId && (params.userId = userId);
    }

    const res = await axiosGet('/devops/performance?action=get&project_name=weeklys', params);
    return res;
  } catch (error) {
    throw new Error(error)
  }
}

/*
* 检测版本号
* */
export const VersionDevOps = async function (params = {}) {
  //let url = `http://${window.location.host}/version/version.json?t=${new Date().getTime()}`;
  let url = `https://${window.location.host}/frontend/version/version.json?t=${new Date().getTime()}`;
  const res = await Axios.get(url, params).then((res)=>{
    const version = res.data.version;
    const localVueVersion = localStorage.getItem('topsVersion')
    if(localVueVersion !== version){
      //alert('检测到新版本，请点击确认刷新页面哦')
      window.sessionStorage.clear()
      window.location.reload(true);
      localStorage.setItem('topsVersion', version)
      return false;
    }else {
      return true;
    }
  });
}













